varying vec2 vUv;
uniform float u_alpha; 
uniform vec2 u_res; 
uniform float u_time;
uniform sampler2D u_positions;
uniform sampler2D u_info;
#define PI 3.1415926538

void main()
{

    vec2 ndc = gl_FragCoord.xy / u_res;
    ndc = ndc * 2.0 - 1.0;
       float aspectRatio = u_res.x / u_res.y;
    ndc.x *= aspectRatio; // Étire les coordonnées x en fonction de l'aspect
    // 
float displacementStrength  = texture2D(u_positions, vUv).a;
    

 
float circle = length(ndc);
float circleSize = cos(u_time)*0.02;
circle = 1.-smoothstep(0.9+circleSize, 0.95+circleSize, circle);
    
float mixMask = mix(circle*0.7, circle*0.2, smoothstep(0., 1., abs(cos(u_time*0.2))));
mixMask = clamp(mixMask, 0., 1.);

    // vec3 color = vec3(vUv.x, 1., vUv.y)*displacementStrength;
    vec3 color = vec3(vUv.x, 1., vUv.y)*1.+displacementStrength;


    // color *= angle;
    // vec3 color = vec3(ndc,  0.5);

    // gl_FragColor = vec4(vUv, 1., u_alpha*circle);
    // gl_FragColor = vec4(vec3(dist*20.), u_alpha);
    // gl_FragColor = vec4(1., vUv, u_alpha*displacementStrength+0.2);
    gl_FragColor = vec4(color, u_alpha);
    gl_FragColor = vec4(color, u_alpha*displacementStrength+0.01);

}
